import styled from 'styled-components';
import { COLOR_TEXT_GREY } from '@common/assets/styles/colors';

export const ModalSC = styled.div`
  position: relative;
  padding: 64px;
  width: 700px;
  max-width: 100%;

  .modal-close {
    background: transparent;
    position: absolute;
    top: 24px;
    right: 24px;
    background: none;
    border: none;
    img {
      width: 12px;
      height: 12px;
    }
  }
`;

export const ModalTitleSC = styled.h2`
  font-size: 24px;
  font-weight: 300;
  line-height: 32px;
  margin-bottom: 8px;
`;

export const ModalCopySC = styled.p`
  line-height: 24px;
  color: ${COLOR_TEXT_GREY};
  margin-bottom: 24px;
`;
